import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FaAngleLeft } from "react-icons/fa";
import { getContactPartnersDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewcontactus = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const contactPartnerView = useSelector((state) => state.contactPartnerView);
  const { contactPartner } = contactPartnerView;

  useEffect(() => {
    if (contactPartnerView) {
      if (contactPartnerView?.loading !== undefined) {
        setLoading(contactPartnerView?.loading);
      }
    }
  }, [contactPartnerView]);

  useEffect(() => {
    if (contactPartner) {
      setValue("firstname", contactPartner?.data[0].firstname);
      setValue("email", contactPartner?.data[0].email);
      setValue("lastname", contactPartner?.data[0].lastname);
      setValue("company", contactPartner?.data[0].company_name);
      setValue("partner",contactPartner?.data[0].partner_type == 0 ? "As an Accountant":"As a Lawyer");
      setValue("message", contactPartner?.data[0].message);
    }
  }, [contactPartner]);

  useEffect(() => {
    dispatch(getContactPartnersDetails(token, id));
  }, [dispatch]);

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Contact Us</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div"></div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  {...register("firstname")}
                  placeholder="Enter  Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  {...register("lastname")}
                  placeholder="Enter Phone"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  {...register("email")}
                  placeholder="Enter Email"
                />
              </div>
              <div className="formInput">
                <label>Company Name</label>
                <input
                  type="text"
                  name="company"
                  disabled={true}
                  {...register("company")}
                  placeholder="Enter Company Name"
                />
              </div>
              <div className="formInput">
                <label>Partner Type</label>
                <input
                  type="text"
                  name="partner"
                  disabled={true}
                  {...register("partner")}
                  placeholder="Enter Partner Type"
                />
              </div>
              <div className="formInput">
                <label>Message</label>

                <textarea
                  type="text"
                  disabled={true}
                  {...register("message")}
                  className="description-textarea"
                  name="message"
                  cols="42"
                  rows="4"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              {/* <div className="formInput"></div> */}

              {/* <button type="submit" disabled={true}>
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewcontactus;
